<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
  >
    <path
      d="M16.6604 23.9167C15.7326 23.9167 14.941 23.5868 14.2854 22.9271C13.6299 22.2674 13.3021 21.4736 13.3021 20.5458C13.3021 19.6181 13.6319 18.8264 14.2917 18.1708C14.9514 17.5153 15.7458 17.1875 16.675 17.1875C17.6042 17.1875 18.3958 17.5181 19.05 18.1792C19.7042 18.8403 20.0319 19.634 20.0333 20.5604C20.0347 21.4868 19.7042 22.2785 19.0417 22.9354C18.3792 23.5924 17.5854 23.9201 16.6604 23.9187M9.11458 7.8125H24.2187L26.875 2.41875C27.1694 1.85903 27.1569 1.31597 26.8375 0.789584C26.5181 0.263195 26.0389 0 25.4 0H7.93333C7.29444 0 6.81528 0.263195 6.49583 0.789584C6.17639 1.31597 6.16389 1.85972 6.45833 2.42083L9.11458 7.8125ZM9.64792 33.3333H23.6854C26.366 33.3333 28.6437 32.3951 30.5187 30.5187C32.3951 28.6424 33.3333 26.3604 33.3333 23.6729C33.3333 22.5507 33.141 21.4576 32.7562 20.3937C32.3715 19.3299 31.816 18.3611 31.0896 17.4875L24.7521 9.89583H8.58125L2.24375 17.4875C1.51736 18.3611 0.961805 19.3299 0.577083 20.3937C0.192361 21.4562 0 22.5493 0 23.6729C0 26.3604 0.938194 28.6424 2.81458 30.5187C4.69097 32.3951 6.96875 33.3333 9.64792 33.3333Z"
      fill="currentColor"
    />
  </svg>
</template>
